import { render, staticRenderFns } from "./LeadComments.vue?vue&type=template&id=ba1ce634&scoped=true"
import script from "./LeadComments.vue?vue&type=script&lang=js"
export * from "./LeadComments.vue?vue&type=script&lang=js"
import style0 from "./LeadComments.vue?vue&type=style&index=0&id=ba1ce634&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba1ce634",
  null
  
)

export default component.exports